import React from 'react';
import { CostCenterRecord } from '../../interfaces/types';
import {
  formatCurrency,
  formatPeriod,
  getSourceClassName,
} from '../../utils/utils';

interface CostCenterCardProps {
  costCenter: CostCenterRecord;
  displayPeriod: string;
  allCards: CostCenterRecord[];
  onClick: () => void;
}

export const CostCenterCard: React.FC<CostCenterCardProps> = ({
  costCenter,
  displayPeriod,
  allCards,
  onClick,
}) => {
  const budgetAmount = costCenter.budgetAmount || 0;
  const consumedAmount = costCenter.consumedAmount || 0;
  const utilization = !consumedAmount
    ? 0
    : Math.min((consumedAmount / budgetAmount) * 100, 100);

  return (
    <button
      type="button"
      className={`cost-center-card ${
        allCards.length <= 3 ? 'max-width-300' : ''
      }`}
      aria-label={`Open details for ${costCenter.name}`}
      onClick={onClick}
    >
      <div className="cost-center-card__header">
        <div>
          <h2>{costCenter.name}</h2>
          <div className="cost-center-card__badges">
            <span
              className={`cost-center-pill cost-center-pill--source ${getSourceClassName(
                costCenter.source,
              )}`}
            >
              {costCenter.source}
            </span>
            <span className="cost-center-pill cost-center-pill--status">
              {costCenter.state}
            </span>
          </div>
        </div>
      </div>

      <div className="cost-center-card__stats">
        <div className="cost-center-stat">
          <span>Users</span>
          <strong>{costCenter.resources?.length || 0}</strong>
        </div>
        <div className="cost-center-stat">
          <span>Period</span>
          <strong>{formatPeriod(displayPeriod)}</strong>
        </div>
        <div className="cost-center-stat">
          <span>Budget</span>
          <strong>{formatCurrency(budgetAmount)}</strong>
        </div>
        <div className="cost-center-stat">
          <span>Consumed</span>
          <strong>{formatCurrency(consumedAmount)}</strong>
        </div>
      </div>

      <div className="cost-center-card__progress-block">
        <div className="cost-center-card__progress-label">
          <span>Utilization</span>
          <strong>{Math.round(utilization)}%</strong>
        </div>
        <div className="cost-center-progress" aria-hidden="true">
          <span style={{ width: `${utilization}%` }} />
        </div>
      </div>
    </button>
  );
};
